import Vue from 'vue'
import Vuex from 'vuex'
import Firebase from './firebase.js'
import ActionLog from './actionlog.js'
import Countries from './countries.js'
Vue.use(Vuex)

const DummyUser = { uid: 'dummy', isDummy: true, isAnonymous: true, email: 'unknown' }

function currencySymbol(cur) {
  switch (cur) {
  case 'EUR': return '€'
  case 'GBP': return '£'
  default: return '$'
  }
}


var cartStore ={
  state: {
    items: {},
    name: 'anon',
    itemCount: 0,
  },
  mutations: {
    updateCart(state, {items, name}) {
      console.log('updateCart', items, name)
      Object.keys(state.items).forEach( k => {
        Vue.delete(state.items, k)
      })
      Object.keys(items).forEach( k=> {
        Vue.set(state.items, k, items[k])
      })
      Vue.set(state, 'itemCount', Object.values(items).reduce((e,v) => e+v, 0))
      if (name) {
        Vue.set(state, 'name', name)
      }
      var count = Object.keys(items).reduce((s,p)=>s+items[p],0)
      localStorage.setItem("shoppingCart-"+(name||state.name), JSON.stringify(items))
    },
  },
  actions: {
    addToCart({state, commit}, {bookid, quantity}) {
      var newCart = Object.assign({}, state.items)
      newCart[bookid] = quantity>=0 ? quantity : Math.max(1, newCart[bookid]||0)
      console.log('addToCart', newCart)
      commit('updateCart', {items: newCart})
    },
    removeFromCart({state, commit}, bookid) {
      var newCart = Object.assign({}, state.items)
      delete newCart[bookid]
      console.log('removeFromCart', bookid, newCart)
      commit('updateCart', {items: newCart})
    },
    reloadCart({state, commit}, uid) {
      console.log('reloadCart', uid)
      var cart = JSON.parse(localStorage.getItem("shoppingCart-"+uid) || '{}')
      commit('updateCart', {items: cart, name: uid})
    },
    clearCart({state, commit}) {
      console.log('clearCart')
      commit('updateCart', {items: {}})
    },
  }
}

var devStore = {
  state: {
    impersonateUid: '',
    developmentClient: false, //(process.env['NODE_ENV'] === 'development'),
    developmentWorkers: (process.env['NODE_ENV'] === 'development')
      && localStorage.getItem("developmentWorkers")==='development',
    testPayments: (process.env['NODE_ENV'] === 'development'),
  },
  mutations: {
    updateDevMode(state, devMode) {
      Vue.set(state, 'developmentClient', devMode)
      var impersonate = devMode && state.impersonateUid
      var rootState = this.state
      Vue.set(state, 'uid', impersonate ? state.impersonateUid : rootState.user.uid)
    },
    updateDevWorkers(state, devMode) {
      Vue.set(state, 'developmentWorkers', devMode)
      localStorage.setItem("developmentWorkers", devMode?"development":"")
    },
    updateTestPayments(state, useTest) {
      Vue.set(state, 'testPayments', useTest)
    },
    updateImpersonateUid(state, iuid) {
      console.log('updateImpersonateUid', iuid)
      Vue.set(state, 'impersonateUid', iuid)
      var rootState = this.state
      if (iuid) {
        Vue.set(rootState, 'uid', iuid)
      } else {
        Vue.set(rootState, 'uid', rootState.user.uid)
      }
    },
  },
  actions: {
  }
}

const initialCurrency = localStorage.getItem("currency") || Countries.guessLocalCurrency() || 'USD'

var store = new Vuex.Store({
  modules: {
    cart: cartStore,
    dev: devStore
  },
  state: {
    user: DummyUser,
    uid: DummyUser.uid,
    isSignedIn: false,
    authState: '',
    authError: '',
    signinProviders: [],
    
    defaultSite: '',
    maxPages: 300,

    currency: initialCurrency,
    currencySymbol: currencySymbol(initialCurrency),    
  },
  mutations: {
    updateUser(state, newUser) {
      console.log('mutating newUser', newUser)
      var newSession = (newUser !== DummyUser && this.state.user === DummyUser)
      newUser = newUser || DummyUser
      Vue.set(state, 'user', newUser)
      Vue.set(state, 'uid', newUser.uid)
      Vue.set(state, 'isSignedIn', !newUser.isAnonymous)
      if (newSession) {
        
        var landing = {referrer: document.referrer,
                       path: window.location.pathname,
                       params: window.location.search,
                       browser: window.navigator.userAgent,
                      }
        if (window.fetch) {
          window.fetch('https://api.db-ip.com/v2/free/self')
            .then(response => response.json())
            .then(data => ActionLog('session', Object.assign({}, landing, {location: data})))
            .catch(error => ActionLog('session', Object.assign({}, landing, {location: error})))
        } else {
          ActionLog('session', landing)
        }
      }
      this.dispatch('reloadCart', newUser.uid)
    },
    updateSite(state, site) {
      Vue.set(state, 'defaultSite', site)
    },
    updateCurrency(state, cur) {
      Vue.set(state, 'currency', cur)
      Vue.set(state, 'currencySymbol', currencySymbol(cur))
      localStorage.setItem("currency", cur)
    },
  },
  actions: {    
    fetchProvidersForEmail({state}, email) {
      Firebase.auth().fetchProvidersForEmail(email)
        .then(function(providers){
          console.log('signin providers', providers)
          if (providers.length) {
            Vue.set(state, 'signinProviders', providers)
          } else {
            Vue.set(state, 'signinProviders', ['none'])
          }
        })
        .catch(function(err){
          console.log('failed to find signin providers', err)
        })
    },
    registerOrSignIn({state, dispatch, commit}, {email, password}) {
      console.log('auth register', email, password)
      state.authError = undefined
      state.authState = 'authorising'
      var credential = Firebase.getCredential(email, password);

      var promise
      if (state.user && state.user.isAnonymous) {
        console.log('auth upgrading from anon', email, password)
        promise = Firebase.auth.currentUser.linkWithCredential(credential)
      } else {
        console.log('auth creating new user', email, password)
        promise = Firebase.auth.createUserWithEmailAndPassword(email, password);
      }

      promise.then(function(){
        state.authState = 'authorised'
        commit('updateUser', Firebase.user)
        console.log('registered ok', email, password, Firebase.user)
        dispatch('logEvent', "new user "+email)
        ActionLog('signup', {email: email})
      }).catch(function(err){
        console.log('failed to register', err)
        if (err.code == 'auth/email-already-in-use') {
          dispatch('signIn', {email:email, password:password})
        } else {
          state.authState = 'error'
          state.authError = err.message
        }
      })
    },
    signIn({state}, {email, password}) {
      console.log('signing in', email, password)
      state.authState = 'authorising'
      Firebase.auth.signInWithEmailAndPassword(email, password)
        .then(function(){
          state.authState = 'authorised'
          console.log('signed in ok', email, password)
        })
        .catch(function(err){
          state.authState = 'error'
          state.authError = err.message
          console.log('failed to signin', err)
        })
    },
    logEvent({state}, message) {
      console.log('EV', message)
      //var ev = Firebase.database.ref("/log/client").push();
      //ev.set(message)
    },
  },
})

Firebase.onAuth(() => store.commit('updateUser', Firebase.user));

export default store




// WEBPACK FOOTER //
// ./src/store.js